const ServiceGroupsChildBlockComponent = {
    data() {
        return {
            loading: false,
            groups: [],
            swiper: null,
            baseUrl: window.appConfig?.baseUrl || '',
        }
    },

    methods: {
        async loadGroups() {
            this.loading = true

            try {
                const resp = await window.serviceGroupsService.getServiceGroups({ page: 1, limit: 200, only_priority: 'Y', only_child: 'Y' })
                const rows = Array.isArray(resp?.data) ? resp.data : []

                this.groups = rows
                    .map(r => this.normalize(r))
                    .filter(x => x.id > 0 && x.title)

                this.$nextTick(() => {
                    this.swiper?.update()
                    this.swiper?.slideTo(0)
                })
            } catch (e) {
                console.error('[ServiceGroupsBlock] loadGroups failed', e)
                this.groups = []
            } finally {
                this.loading = false
            }
        },

        normalize(row) {
            const id = Number(row?.id || 0) || 0

            const title = String(row?.web_title || row?.title || '').trim()

            const description = String(row?.web_description || '').trim()

            const url = String(row?.url || '').trim() || (id ? `/departments/${id}` : '#')

            const icon = this.getImageUrl(row?.web_image_url)

            const priceFrom = Number(row?.priceFrom || row?.price_from || 0) || 0

            return {
                id,
                title,
                description,
                icon,
                url,
                priceFrom,
            }
        },

        getImageUrl(webImage) {
            const v = String(webImage ?? '').trim()
            if (!v) return ''

            if (v.startsWith('http://') || v.startsWith('https://')) return v

            const base = String(this.baseUrl || '').replace(/\/+$/, '')

            if (v.startsWith('/')) return base ? `${base}${v}` : v

            return base ? `${base}/uploads/${v}` : `/uploads/${v}`
        },

        initSwiper() {
            const root = this.$el
            const slider = root.querySelector('.servicesSlider')
            const nextEl = root.querySelector('.slider__top-next')
            const prevEl = root.querySelector('.slider__top-prev')

            if (!slider || !window.Swiper) return

            this.swiper = new window.Swiper(slider, {
                slidesPerView: 1.15,
                spaceBetween: 16,
                navigation: { nextEl, prevEl },
                breakpoints: {
                    576: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    1024: { slidesPerView: 4 },
                },
            })
        },
    },

    mounted() {
        console.log(123123);
        this.initSwiper()
        this.loadGroups()
    },
}

window.ServiceGroupsChildBlockComponent = ServiceGroupsChildBlockComponent